import { ApolloClient } from '@apollo/client';
import logger from '../common/helpers/logger/logger';
import { useMutationHelper } from '../common/helpers/data/useMutationHelper';
import { FOOTER_CONTENT_QUERY } from '../queries/footerPage/footerContent';
import { LEAD_FORM_QUERY } from '../queries/footerPage/leadForm';

interface FetchFooterContentOptions {
  slug: string;
}

export interface FooterPageData {
  id: number;
  title: string;
  content: string;
}

export const fetchFooterContent = async (
  client: ApolloClient<unknown>,
  options: FetchFooterContentOptions,
): Promise<FooterPageData> => {
  try {
    logger.logInfo('commonService.fetchFooterContent', 'Begin');

    const variables = { slug: options.slug, errorPolicy: 'all' };

    const response = await client.query({
      query: FOOTER_CONTENT_QUERY,
      variables: variables,
    });

    return response?.data?.page;
  } catch (error) {
    logger.logError(
      'commonService.fetchFooterContent',
      'Error retrieving from query.',
      {
        options,
        error,
      },
    );
    throw error;
  }
};

interface SubmitEnquiryOptions {
  name: string;
  email: string;
  phone: string;
  message: string;
  source: string;
  recaptcha: string;
}

export const buildSubmitEnquiryVariables = (options: SubmitEnquiryOptions) => {
  return {
    name: options.name,
    email: options.email,
    phone: options.phone,
    message: options.message,
    source: options.source,
    recaptcha: options.recaptcha,
  };
};
export const useMutationSubmitEnquiry = () => {
  try {
    logger.logInfo('commonService.useMutationSubmitEnquiry', 'Begin');
    return useMutationHelper(LEAD_FORM_QUERY);
  } catch (error) {
    logger.logError(
      'commonService.useMutationSubmitEnquiry',
      'Error creating mutation.',
      error,
    );
    throw error;
  }
};
